<template>
  <el-drawer
    v-model="visible"
    :close-on-click-modal="false"
    :modal="false"
    :append-to-body="false"
    :fullscreen="false"
    :size="drawerWidthPct"
    destroy-on-close
    class="add-scheduled-task-drawer"
    modal-class="add-scheduled-task-drawer"
    @opened="onOpened"
    @closed="onClosed"
  >
    <template v-if="drawerOpened">
      <!-- ADD TASK -->
      <add-scheduled-task-form
        :selected-project-id="projectId"
        :custom-sticky-top-pixels="-5"
        :selected-date="selectedDate"
        :existing-scheduled-task-id="existingScheduledTaskId"
        @canceled="handleCancel()"
        @scheduled-task-created="handleScheduledTaskCreated"
        @scheduled-task-deleted="handleScheduledTaskDeleted"
      />
    </template>
  </el-drawer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AddScheduledTaskForm from './add-scheduled-task-form.vue'
import { IScheduledTask } from '@/api/types/response.types'

export default defineComponent({
  name: 'AddScheduledTaskDrawer',

  components: {
    AddScheduledTaskForm,
  },

  props: {
    showDrawer: {
      type: Boolean,
      default: false,
    },
    // Default project to select after projects dropdown is loaded
    projectId: {
      type: Number,
      required: true,
    },
    existingScheduledTaskId: {
      type: Number,
      default: null,
    },
    selectedDate: {
      type: Date,
      required: true,
    },
  },

  emits: [
    'scheduled-task-created',
    'scheduled-task-deleted',
    'update:showDrawer',
  ],

  data() {
    return {
      drawerOpened: false,
      showAddTaskPanel: true,
    }
  },

  computed: {
    visible: {
      get(): boolean {
        return this.showDrawer
      },
      set(newValue: boolean) {
        this.$emit('update:showDrawer', newValue)
      },
    },
    drawerWidthPct(): string {
      if (this.$screen.isTabletOrMobile(this.$mq)) {
        return '100%'
      }
      return '680px'
    },
  },

  mounted() {
    // el-drawer only emits "opened" after its enter transition, which doesn't run when it starts out open (as from a
    // link to a scheduled task)
    if (this.showDrawer) {
      this.drawerOpened = true
    }
  },

  methods: {
    onOpened() {
      this.drawerOpened = true
    },

    onClosed() {
      this.drawerOpened = false
    },

    handleCancel() {
      this.$emit('update:showDrawer', false)
    },

    handleScheduledTaskCreated(scheduledTask: IScheduledTask) {
      this.$emit('scheduled-task-created', scheduledTask)
    },

    handleScheduledTaskDeleted(scheduledTaskId: number) {
      this.$emit('scheduled-task-deleted', scheduledTaskId)
    },
  },
})
</script>

<style lang="scss">
.add-scheduled-task-drawer {
  /* Default drawer overrides to remove title but keep "X" close icon */
  .el-drawer__header {
    padding-bottom: 0;
    border-bottom: none;
  }
  .el-drawer__body {
    padding-top: 0;
  }

  &__header {
    padding: 8px 0 8px 20px;

    > h1 {
      @include lettering--h3;
    }
  }

  &__nav {
    display: flex;
    padding-top: 5px;

    > div {
      @include lettering--p-sm;
      font-weight: $bold;
      padding: 6px 0;
      margin: 0 12px;
      display: inline-block;
      color: var(--color-text-third);
      cursor: pointer;

      &:first-child {
        margin-left: 0;
      }

      &.selected {
        color: var(--color-text-secondary);
        border-bottom: solid 2px $projects--theme-color;
      }
    }
  }
}
</style>
